import { bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import DiscardableForm from '../../generic/DiscardableForm';
import TimestampInfo from '../../generic/TimestampInfo';
import { brandShape } from '../../prop-types';

function BrandForm({ model, onChange, onSubmit, newModel, onDiscard }) {
  const {
    name,
    code,
    created,
    lastModified,
    createdBy,
    lastModifiedBy,
    isBrandGroup,
    urlKey,
    shopStatus,
    cluster,
    family,
  } = model;
  const inputProps = { onChange, readOnly: !onSubmit };

  return (
    <DiscardableForm onSubmit={onSubmit} onDiscard={onDiscard}>
      <Row>
        <Col>
          {!inputProps.readOnly && (
            <FormGroup row>
              <Label sm={3} for="br-name" className="required">
                Name
              </Label>
              <Col sm={9}>
                <Input
                  id="br-name"
                  name="name"
                  value={name || ''}
                  {...inputProps}
                />
              </Col>
            </FormGroup>
          )}
          <FormGroup row>
            <Label sm={3} for="br-code">
              Brand Code
            </Label>
            <Col sm={9}>
              <Input
                id="br-code"
                name="code"
                value={code || ''}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          {inputProps.readOnly && (
            <FormGroup row>
              <Label sm={3} for="br-isBrandGroup">
                Brand Group
              </Label>
              <Col sm={9}>
                <span className="form-control-plaintext">
                  {isBrandGroup ? 'Yes' : 'No'}
                </span>
              </Col>
            </FormGroup>
          )}
        </Col>
        <Col>
          <FormGroup row>
            <Label sm={3} for="br-urlKey">
              URL Key
            </Label>
            <Col sm={9}>
              <Input id="br-urlKey" name="urlKey" value={urlKey} readOnly />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={3} for="br-shopStatus">
              Status
            </Label>
            <Col sm={9}>
              <Input
                id="br-shopStatus"
                name="shopStatus"
                value={shopStatus}
                readOnly
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={3} for="br-cluster">
              Cluster
            </Label>
            <Col sm={9}>
              <Input id="br-cluster" name="cluster" value={cluster} readOnly />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={3} for="br-family">
              Family
            </Label>
            <Col sm={9}>
              <Input id="br-family" name="family" value={family} readOnly />
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {!newModel && (
            <Row className="small">
              <Col>
                <TimestampInfo
                  timestamp={created}
                  actionName="created"
                  author={createdBy}
                  displayAttribute="inline"
                />
                <TimestampInfo
                  timestamp={lastModified}
                  actionName="lastModified"
                  author={lastModifiedBy}
                  displayAttribute="inline"
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </DiscardableForm>
  );
}

BrandForm.propTypes = {
  model: brandShape.isRequired,
  onChange: func,
  onSubmit: func,
  onDiscard: func,
  newModel: bool,
};

BrandForm.defaultProps = {
  onChange: undefined,
  onSubmit: undefined,
  onDiscard: undefined,
  newModel: false,
};

export default BrandForm;
